import { render } from "./uImage.vue?vue&type=template&id=794aa516"
import script from "./uImage.vue?vue&type=script&lang=js"
export * from "./uImage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\DongRi\\DongRi-Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__